module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "recommend-cell"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'bookshelf',
        params: {
          catid: _vm.value.catid
        },
        query: {
          name: _vm.value.catname
        }
      }
    }
  }, [_c('span', {
    staticClass: "icon",
    class: _vm._f("icon")(_vm.value.catname)
  }), _vm._v(" "), _c('span', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.value.catname))]), _vm._v(" "), _c('span', {
    staticClass: "icon icon-right"
  })]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, _vm._l((_vm.value.items), function(item, index) {
    return _c('movie-cover', {
      key: index,
      staticClass: "home-movie",
      attrs: {
        "value": item
      }
    })
  }), 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-56766f14","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/view/home/Recommendation.vue
// module id = 327
// module chunks = 0